import * as React from "react"
import { Select, HStack, Switch, Text, FormLabel, Tooltip, Box } from "@chakra-ui/react"

import { useTableParams } from "lib/hooks/useTableParams"
import { categories, postTypes, regionsIncNed } from "lib/static/filters"

export interface PostFilters {
  type: string
  region: string
  category: string
}
interface Props {
  filters: PostFilters
  onSetFilters: (filters: PostFilters) => void
  includePastPosts?: boolean
  setIncludePastPosts?: React.Dispatch<React.SetStateAction<boolean>>
}

export function PostsFilterbar({ filters, onSetFilters, includePastPosts, setIncludePastPosts }: Props) {
  const [_, setParams] = useTableParams()
  const postFilters = filters

  const setPostFilters = ({ filter, value }: { filter: keyof PostFilters; value: string }) => {
    onSetFilters({ ...postFilters, [filter]: value })
    setParams({ [filter]: value })
  }

  return (
    <HStack spacing={4}>
      <Select
        placeholder="Alle typen"
        value={postFilters.type}
        onChange={({ target: { value } }) => setPostFilters({ filter: "type", value })}
        aria-label="Selecteer type"
      >
        {Object.entries(postTypes).map(([label, value]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Select>
      <Select
        placeholder="Alle regio's"
        value={postFilters.region}
        onChange={({ target: { value } }) => setPostFilters({ filter: "region", value })}
        aria-label="Selecteer regio"
      >
        {regionsIncNed.map((region) => (
          <option key={region} value={region}>
            {region}
          </option>
        ))}
      </Select>
      <Select
        placeholder="Alle categorieën"
        value={postFilters.category}
        onChange={({ target: { value } }) => setPostFilters({ filter: "category", value })}
        aria-label="Selecteer categorie"
        minW="180px"
      >
        {categories.map((category, i) => (
          <option key={i} value={category}>
            {category}
          </option>
        ))}
      </Select>
      {setIncludePastPosts && (
        <Tooltip label="bevat berichten met een deadline in het verleden">
          <HStack>
            <Switch
              aria-label="include past posts"
              id="include-past"
              onChange={() => setIncludePastPosts(!includePastPosts)}
              colorScheme="pink"
            />
            <FormLabel htmlFor="include-past" fontSize="sm" m={0} cursor="pointer" minW="180px">
              Inclusief eerdere berichten
            </FormLabel>
          </HStack>
        </Tooltip>
      )}
    </HStack>
  )
}
